import { HttpMethod, useUserRequest } from "../common/lib/fetch";
import { RequestOptions } from "../common/lib/fetch/useRequest";

const useCancelStagedPurchaseOrder = (stagedPurchaseOrderId: string, options?: RequestOptions) => {
  return useUserRequest<void>({
    method: HttpMethod.POST,
    path: `/api/stagedPurchaseOrders/${stagedPurchaseOrderId}/cancel`
  }, options);
}

export default useCancelStagedPurchaseOrder;
